export const AlertType = {
    standard: "STANDARD",
    user_input: "USER_INPUT"
}
